<ng-container *transloco="let t; read: 'pagination'">
  <div class="jump-to-page-pagination-container"
    [ngStyle]="containerStyles()">
    <div class="pagination-status mat-body-1">
    <span>
      {{
        t('viewing_from_to', {
          from: getResultsFromPage(pageMeta().current_page),
          to: getResultsToPage(pageMeta().current_page),
          totalCount: ((pageMeta()?.total_count || 0) | number)
        })
      }}
    </span>
    </div>

    <div class="pagination-actions">
      <button mat-icon-button
        class="mat-default"
        (click)="onPageChange(pageMeta()?.current_page - 1)"
        [attr.aria-label]="t('aria_prev')"
        [disabled]="!pageMeta()?.prev_page"
        [attr.aria-disabled]="!pageMeta()?.prev_page"
        mat-stroked-button>
        <mat-icon class="mat-icon-rtl-mirror">chevron_left</mat-icon>
      </button>

      @if (jumpToPage()) {
        <div class="jump-to-page-container">
          <span>{{ t('page') }}</span>
          <accredible-text-input [dataCy]="'input-jump-to-page'"
            [ariaLabel]="t('jump_to_page_aria_label')"
            [formControlRef]="jumpToPageControl"
            (keydown.enter)="onJumpToPage()"
            (blurEvent)="onJumpToPage()"/>
          <span>{{ t('total_pages', { total: pageMeta().total_pages || 0 }) }}</span>
        </div>
      }

      <button mat-icon-button
        class="mat-default"
        (click)="onPageChange(pageMeta()?.current_page + 1)"
        [attr.aria-label]="t('aria_next')"
        [disabled]="!pageMeta()?.next_page"
        [attr.aria-disabled]="!pageMeta()?.next_page"
        mat-stroked-button>
        <mat-icon class="mat-icon-rtl-mirror">chevron_right</mat-icon>
      </button>
    </div>
  </div>
</ng-container>